<mat-button-toggle-group #group="matButtonToggleGroup" (change)="onChange($event)" [value]="lc(value)"
                         hideSingleSelectionIndicator="true">
  @for (choice of choices; track choice) {
  <mat-button-toggle [disableRipple]="true" [value]="lc(choice.value)" [ngClass]="{dim: choice.dim}">
    <span class="round {{choice.color}} {{choice.icon || choice.label ? 'tight' : ''}}">
      <mat-icon [ngClass]="{'large-icon': choice.largeIcon}" *ngIf="choice.icon" [svgIcon]="choice.icon"></mat-icon>

      <div class="swatch" *ngIf="choice.swatch" [style.background-color]="choice.swatch"></div>

      <div class="swatch" *ngIf="choice.imageSwatch" [style.background-image]="'url(' + choice.imageSwatch + ')'"></div>

      <div class="label" [ngClass]="[choice.label.class]" *ngIf="choice.label" [innerHtml]="choice.label.text"></div>
    </span>
    <div class="caption" *ngIf="choice.caption" [innerHtml]="choice.caption"></div>
  </mat-button-toggle>
  }
</mat-button-toggle-group>

<ng-content></ng-content>

